import { PasswordInput, TextInput, URLInput } from '@components';
import { DEFAULT_USER_COLORS } from '@config/colors';
import Step1 from './CompanyOnboarding/Step1';
import Step2 from './CompanyOnboarding/Step2';
import Step3 from './CompanyOnboarding/Step3';
import { ApiCaller } from '../../config';

export const companyOnboardingInputs = {
    0: [
        { name: 'firstName', placeholder: 'First Name', type: 'text', component: TextInput },
        { name: 'lastName', placeholder: 'Last Name', type: 'text', component: TextInput },
        { name: 'email', placeholder: 'Email', type: 'email', component: TextInput },
        {
            name: 'phoneNo',
            placeholder: 'Phone',
            component: TextInput,
            type: 'text',
            helperText: 'e.g. (123) 456-7890',
        },
        {
            name: 'passwords.password',
            placeholder: 'Password',
            component: PasswordInput,
            triggerKey: 'passwords',
        },
        {
            name: 'passwords.confirmPassword',
            placeholder: 'Confirm Password',
            component: PasswordInput,
            triggerKey: 'passwords',
        },
    ],
    1: [
        {
            name: 'companyName',
            placeholder: 'Company Name',
            type: 'text',
            component: TextInput,
        },
        { name: 'companyUrl', placeholder: 'URL', type: 'text' , component: URLInput },
    {
        name: 'companyEmail',
        placeholder: 'Company Email Address',
        type: 'email',
        component: TextInput,
    },
    {
        name: 'employeeCount',
        placeholder: 'How many employees do you have?',
        type: 'number',
        component: TextInput,
    },
        ,
    ],
};

export const companyOnboardingSteps = [
    {
        title: 1,
        content: <Step1 />,
        validate: async (data) => {
            await ApiCaller.Get(
                `/step/validation?email=${data.email}&password=${data.passwords.password}&phoneNo=${data.phoneNo}`,
            );
        },
    },
    {
        title: 2,
        content: <Step2 />,
        validate: async (data) => {
            await ApiCaller.Get(
                `/company/url/validation?companyUrl=${data.companyUrl}&isExist=0`,
            );
        },
    },
    {
        title: 3,
        content: <Step3 />,
        validate: () => true,
    },
];

export const companyOnboardingDefaults = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNo: '',
    passwords: {
        password: undefined,
        confirmPassword: undefined,
    },
    files: [],
    companyName: '',
    companyEmail: '',
    companyUrl: '',
    employeeCount: '',
    subscriptionId: undefined,
    colors: DEFAULT_USER_COLORS,
};
